/*
 * An absolute URL on the canonical host for a root-relative path, like
 * home_url() in PHP. A root-relative link resolves against the current host,
 * and on the campaign host only campaigns are served, so every other page
 * 404s there. REST calls stay relative: they must stay same-origin.
 */
export default function homeUrl(path) {
	var base = window.profetWPVars && window.profetWPVars.homeUrl;

	path = path || '/';

	if (path.charAt(0) !== '/') {
		path = '/' + path;
	}

	return base ? base.replace(/\/+$/, '') + path : path;
}
